import { gql } from '@apollo/client';

export const bookingQuery = gql`
  query booking($reference: String!) {
    booking(reference: $reference) {
      reference
      salesChannelCode
      externalBookingReferences {
        source
        externalId
      }
      passengers {
        id
        type
      }
      customer {
        firstName
        lastName
        companyName
      }
      status
      currency
      payments {
        amountWithCurrency
        paymentStatus
      }
      expiryTimestamp
      totalPriceToBePaidWithCurrency
      totalPriceWithCurrency
      onHoldWithCurrency {
        depositAmount
        expiryTimestamp
      }
      outbound {
        ...quoteJourneyLeg
      }
      inbound {
        ...quoteJourneyLeg
      }
    }
  }

  fragment quoteJourneyLeg on Leg {
    id
    origin {
      name
    }
    destination {
      name
    }
    classOfService {
      code
      name
    }
    products {
      name
      cancelled
      passenger {
        id
        type
        disabilityType
      }
      priceWithCurrency
    }
    timing {
      isoDate
      date
      departs
      arrives
    }
    serviceName
    serviceType {
      code
    }
  }
`;
